import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "@/pages/Home";
import Editor from "@/pages/Editor";
import Tools from "@/pages/Tools";
import Category from "@/pages/Category";
import Pricing from "@/pages/Pricing";
import BillingSuccess from "@/pages/BillingSuccess";
import Account from "@/pages/Account";
import SEOLanding from "@/pages/SEOLanding";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Admin from "@/pages/Admin";
import Layout from "@/components/Layout";
import AuthCallback from "@/components/AuthCallback";
import { AuthProvider } from "@/contexts/AuthContext";
import { TEMPLATES } from "@/data/templates";
import { Toaster } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  // Detect Emergent OAuth callback BEFORE any routes render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/category/:slug" element={<Category />} />
        <Route path="/editor/:templateId" element={<Editor />} />
        <Route path="/tools" element={<Tools />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/billing/success" element={<BillingSuccess />} />
        <Route path="/account" element={<Account />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin-dashboard" element={<Admin />} />
        {/* SEO landing pages — one per template for organic search */}
        {TEMPLATES.map(t => (
          <Route
            key={t.id}
            path={`/free-${t.id}-template`}
            element={<SEOLanding templateId={t.id} />}
          />
        ))}
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </HelmetProvider>
    </div>
  );
}

export default App;
